module.exports = __webpack_public_path__ + "static/Tricia-Noel_18_04.1f0056cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Tricia-Noel_18_04.jpg
// module id = 137
// module chunks = 35783957827783 245263612173606